<div>
  <form [formGroup]="searchForm" novalidate ngxsForm="main.omniSearchForm">
    @if (showSearch) {
      <mat-form-field ngClass="width-20" [ngClass.lt-md]="{'width-20': false}">
        <input #searchInput matInput formControlName="search" [matAutocomplete]="auto">
        <mat-label fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.2rem">
          <mat-icon>search</mat-icon>
          <div>Search</div>
        </mat-label>
        <button type="button" mat-icon-button matSuffix aria-label="Close Omni-Search" (click)="close()">
          <mat-icon class="color-accent">close</mat-icon>
        </button>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
          @for (result of searchResults | async; track result) {
            <mat-option [value]="result" class="result-option">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div>
                  <mat-icon [color]="result.isTravel() ? 'primary' : 'accent'">{{ result.isTravel() ?
                    'airplanemode_active' : 'person'
                    }}
                  </mat-icon>
                </div>
                <div fxLayout="column">
                  <div>
                    <span class="result-title">{{ result.userName }}</span>
                  </div>
                  @if (result.isTravel()) {
                    <div>
                      <span class="result-details">{{ result.id }}: {{ result.travelType | travelType
                      }}</span>
                    </div>
                  }
                  @if (result.isTravel()) {
                    <div>
                      <span class="result-details">{{result.departureDate | date : 'dd-MMM-yyyy'}} -
                      {{result.returnDate | date : 'dd-MMM-yyyy'}}</span>
                    </div>
                  }
                </div>
              </div>
            </mat-option>
          }
          @if ((searchResults | async)?.length === 0) {
            <mat-option>No results found.</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
  </form>
  @if (!showSearch) {
    <button type="button" mat-icon-button
      (click)="openSearch()"><mat-icon>search</mat-icon></button>
    }
  </div>